/* eslint-disable */

const routes = {"payments:exchange": "/payment/exchange/", "payments:return": "/payment/return/", "customer_portal:home": "/klanten/", "customer_portal:plans:list": "/klanten/sleutels/", "customer_portal:users:login": "/klanten/inloggen/", "customer_portal:users:logout": "/klanten/uitloggen/", "customer_portal:users:profile": "/klanten/profiel/", "customer_portal:users:password_reset": "/klanten/wachtwoord-vergeten/", "customer_portal:users:password_reset_done": "/klanten/wachtwoord-vergeten/verstuurd/", "customer_portal:users:password_reset_confirm": "/klanten/wachtwoord-vergeten/opnieuw-instellen/<uidb64>/<token>/", "customer_portal:users:password_reset_complete": "/klanten/wachtwoord-vergeten/voltooid/", "customer_portal:orders:create": "/klanten/nabestelling/", "customer_portal:orders:complete": "/klanten/nabestelling/bedankt/", "orders:create": "/tr/", "orders:update": "/tr/\u00f6nsipari\u015fler/<int:order_number>/", "orders:complete": "/tr/Te\u015fekk\u00fcrler/"} as const;

// examples:
// const routes = {
//     home: "/",
//     "books:book_detail": "/books/<int:pk>/",
//     "users:reset_password": "/users/reset-password/<uidb64>/<token>/",
// } as const;

type _UnwrapParam<
    P extends string,
    S extends string[]
> = P extends `<${infer Q}>` ? [Q, ...S] : S;

type _Match<
    T extends string,
    S extends string[]
> = T extends `${infer P}/${infer R}`
    ? _Match<R, _UnwrapParam<P, S>>
    : _UnwrapParam<T, S>;

type Match<T extends string> = _Match<T, []>[number];

type ExtractKey<T extends string> = T extends `${string}:${infer K}` ? K : T;
type ExtractType<T extends string> = T extends `int:${string}`
    ? number
    : string;
type Extractor<T extends string> = {
    [K in Match<T> as ExtractKey<K>]: ExtractType<K>;
};

export type RouteKeys = keyof typeof routes;
export type Route<T extends RouteKeys> = (typeof routes)[T];
export type RouteParams<T extends RouteKeys> = Extractor<Route<T>>;

function reverseUrl<T extends RouteKeys>(
    urlName: T,
    ...args: Record<string, never> extends RouteParams<T>
        ? [args?: never]
        : [args: RouteParams<T>]
): Route<T> {
    const url = routes[urlName];

    const argTokens = url.match(/<(\w+\:)?\w*>/g);
    if (!argTokens && args.length > 0) {
        throw (
            "Invalid URL lookup: URL '" +
            urlName +
            "' does not expect any arguments."
        );
    }

    if (argTokens) {
        return argTokens.reduce((acc, token) => {
            if (args[0] === undefined) {
                throw (
                    "Invalid URL lookup: URL '" +
                    urlName +
                    "' expects " +
                    argTokens.length +
                    " arguments."
                );
            }
            // Remove the type prefix from the token, e.g. "<int:pk>" -> "pk"
            const argName = token.slice(1, -1).replace(/^\w+\:/, "") as keyof RouteParams<T>;
            // Get the value of the argument, e.g. { pk: 1 } -> 1
            const argValue = String(args[0][argName]);
            return acc.replace(token, argValue);
        }, url) as Route<T>;
    }

    return url;
}

export default reverseUrl;
